import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';

function FortuneHistory() {
    const navigate = useNavigate();
    const memberId = localStorage.getItem("lighthouse_memberId");
    const isLoggedIn = memberId && memberId !== 'null' && memberId !== 'undefined';

    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState('all');
    const [currentMonth, setCurrentMonth] = useState(new Date());
    const [fortuneTypes, setFortuneTypes] = useState([]);

    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const APIKEY = process.env.REACT_APP_UNSE_API_KEY;
    const siteCode = process.env.REACT_APP_SITE_CODE_LIGHTHOUSE;

    // 로컬 시간 기준 YYYY-MM-DD 형식 변환 (UTC 변환 방지)
    const formatLocalDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    useEffect(() => {
        if (isLoggedIn) {
            fetchHistory();
        } else {
            setLoading(false);
        }
    }, [isLoggedIn]);

    const fetchHistory = () => {
        setLoading(true);

        $.ajax({
            url: `${API_BASE_URL}/getFortuneHistory`,
            type: "POST",
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify({
                member_id: memberId,
                site_code: siteCode
            }),
            headers: { APIKEY: APIKEY },
            success: function (res) {
                setLoading(false);
                if (res.code === '0') {
                    setHistory(res.list || []);
                    // 운세 타입 추출
                    const types = [...new Set((res.list || []).map(item => item.UNSE_TITLE))];
                    setFortuneTypes(types);
                }
            },
            error: function (err) {
                setLoading(false);
                console.error("운세 내역 조회 에러:", err);
            }
        });
    };

    const handleViewResult = (logId) => {
        localStorage.setItem('lighthouse_unseLogId', logId);
        navigate('/lighthouse/UnseResult');
    };

    // 달력 관련 함수들
    const getDaysInMonth = (date) => {
        const year = date.getFullYear();
        const month = date.getMonth();
        const firstDay = new Date(year, month, 1);
        const lastDay = new Date(year, month + 1, 0);
        const daysInMonth = lastDay.getDate();
        const startingDay = firstDay.getDay();
        return { daysInMonth, startingDay };
    };

    const getHistoryForDate = (date) => {
        const dateStr = formatLocalDate(date);
        return history.filter(item => {
            const itemDate = formatLocalDate(new Date(item.REG_DATE));
            return itemDate === dateStr;
        });
    };

    const hasHistoryOnDate = (date) => {
        return getHistoryForDate(date).length > 0;
    };

    const prevMonth = () => {
        setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1));
        setSelectedDate(null);
    };

    const nextMonth = () => {
        setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1));
        setSelectedDate(null);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
    };

    // 필터링된 히스토리
    const getFilteredHistory = () => {
        let filtered = history;

        if (selectedFilter !== 'all') {
            filtered = filtered.filter(item => item.UNSE_TITLE === selectedFilter);
        }

        if (selectedDate) {
            const dateStr = formatLocalDate(selectedDate);
            filtered = filtered.filter(item => {
                const itemDate = formatLocalDate(new Date(item.REG_DATE));
                return itemDate === dateStr;
            });
        }

        return filtered;
    };

    const renderCalendar = () => {
        const { daysInMonth, startingDay } = getDaysInMonth(currentMonth);
        const days = [];
        const weekDays = ['일', '월', '화', '수', '목', '금', '토'];

        // 요일 헤더
        const headerRow = weekDays.map((day, i) => (
            <div key={`header-${i}`} style={{
                textAlign: 'center',
                padding: '8px 0',
                fontSize: '12px',
                color: i === 0 ? '#ff6b6b' : i === 6 ? '#4dabf7' : '#888'
            }}>
                {day}
            </div>
        ));

        // 빈 칸
        for (let i = 0; i < startingDay; i++) {
            days.push(<div key={`empty-${i}`} />);
        }

        // 날짜
        for (let day = 1; day <= daysInMonth; day++) {
            const date = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), day);
            const hasHistory = hasHistoryOnDate(date);
            const isSelected = selectedDate &&
                selectedDate.getDate() === day &&
                selectedDate.getMonth() === currentMonth.getMonth() &&
                selectedDate.getFullYear() === currentMonth.getFullYear();
            const isToday = new Date().toDateString() === date.toDateString();

            days.push(
                <div
                    key={day}
                    onClick={() => hasHistory && setSelectedDate(date)}
                    style={{
                        textAlign: 'center',
                        padding: '8px 0',
                        fontSize: '14px',
                        cursor: hasHistory ? 'pointer' : 'default',
                        background: isSelected ? 'rgba(255,215,0,0.3)' : 'transparent',
                        borderRadius: '8px',
                        color: hasHistory ? '#fff' : '#555',
                        fontWeight: isToday ? 'bold' : 'normal',
                        position: 'relative'
                    }}
                >
                    {day}
                    {hasHistory && (
                        <div style={{
                            position: 'absolute',
                            bottom: '2px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: '4px',
                            height: '4px',
                            borderRadius: '50%',
                            background: '#FFD700'
                        }} />
                    )}
                </div>
            );
        }

        return (
            <div style={{ marginBottom: '20px' }}>
                {/* 월 네비게이션 */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '15px'
                }}>
                    <button onClick={prevMonth} style={{
                        background: 'none',
                        border: 'none',
                        color: '#fff',
                        fontSize: '20px',
                        cursor: 'pointer',
                        padding: '5px 10px'
                    }}>&#8249;</button>
                    <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#fff' }}>
                        {currentMonth.getFullYear()}년 {currentMonth.getMonth() + 1}월
                    </span>
                    <button onClick={nextMonth} style={{
                        background: 'none',
                        border: 'none',
                        color: '#fff',
                        fontSize: '20px',
                        cursor: 'pointer',
                        padding: '5px 10px'
                    }}>&#8250;</button>
                </div>

                {/* 달력 그리드 */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(7, 1fr)',
                    gap: '2px',
                    background: 'rgba(255,255,255,0.05)',
                    borderRadius: '12px',
                    padding: '10px'
                }}>
                    {headerRow}
                    {days}
                </div>
            </div>
        );
    };

    if (!isLoggedIn) {
        return (
            <div style={{
                padding: 'clamp(40px, 10vw, 50px) 20px',
                textAlign: 'center',
                color: '#aaa',
                maxWidth: '540px',
                margin: '0 auto'
            }}>
                <div style={{ fontSize: 'clamp(36px, 9vw, 48px)', marginBottom: '20px' }}>&#128274;</div>
                <p style={{ fontSize: 'clamp(14px, 3.5vw, 16px)' }}>로그인 후 이용해주세요.</p>
            </div>
        );
    }

    const filteredHistory = getFilteredHistory();

    return (
        <div style={{
            padding: '20px',
            paddingBottom: '40px',
            maxWidth: '540px',
            margin: '0 auto',
            boxSizing: 'border-box',
            position: 'relative',
            zIndex: 99
        }}>
            <h2 style={{
                fontSize: '18px',
                fontWeight: 'bold',
                color: '#fff',
                marginBottom: '20px',
                textAlign: 'center'
            }}>
                운세 히스토리
            </h2>

            {/* 달력 */}
            {renderCalendar()}

            {/* 필터 */}
            <div style={{
                display: 'flex',
                gap: '8px',
                marginBottom: '15px',
                flexWrap: 'wrap'
            }}>
                <button
                    onClick={() => { setSelectedFilter('all'); setSelectedDate(null); }}
                    style={{
                        padding: '8px 16px',
                        fontSize: '13px',
                        background: selectedFilter === 'all' ? '#FFD700' : 'rgba(255,255,255,0.1)',
                        color: selectedFilter === 'all' ? '#000' : '#fff',
                        border: 'none',
                        borderRadius: '20px',
                        cursor: 'pointer'
                    }}
                >
                    전체
                </button>
                {fortuneTypes.map((type, i) => (
                    <button
                        key={i}
                        onClick={() => { setSelectedFilter(type); setSelectedDate(null); }}
                        style={{
                            padding: '8px 16px',
                            fontSize: '13px',
                            background: selectedFilter === type ? '#FFD700' : 'rgba(255,255,255,0.1)',
                            color: selectedFilter === type ? '#000' : '#fff',
                            border: 'none',
                            borderRadius: '20px',
                            cursor: 'pointer'
                        }}
                    >
                        {type}
                    </button>
                ))}
            </div>

            {/* 선택된 날짜 표시 */}
            {selectedDate && (
                <div style={{
                    padding: '10px 15px',
                    marginBottom: '15px',
                    background: 'rgba(255,215,0,0.1)',
                    borderRadius: '8px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <span style={{ color: '#FFD700', fontSize: '14px' }}>
                        {selectedDate.getMonth() + 1}월 {selectedDate.getDate()}일
                    </span>
                    <button
                        onClick={() => setSelectedDate(null)}
                        style={{
                            background: 'none',
                            border: 'none',
                            color: '#888',
                            fontSize: '12px',
                            cursor: 'pointer'
                        }}
                    >
                        날짜 선택 해제
                    </button>
                </div>
            )}

            {/* 히스토리 목록 */}
            {loading ? (
                <div style={{ padding: '40px 20px', textAlign: 'center', color: '#888' }}>
                    로딩 중...
                </div>
            ) : filteredHistory.length === 0 ? (
                <div style={{ padding: '40px 20px', textAlign: 'center', color: '#888' }}>
                    {selectedDate ? '해당 날짜에 운세 기록이 없습니다.' : '운세 기록이 없습니다.'}
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {filteredHistory.map((item, index) => (
                        <div
                            key={index}
                            onClick={() => handleViewResult(item.ID)}
                            style={{
                                background: '#273250',
                                borderRadius: '12px',
                                padding: '15px',
                                cursor: 'pointer',
                                transition: 'background 0.2s ease'
                            }}
                        >
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                marginBottom: '8px'
                            }}>
                                <div style={{
                                    fontSize: '15px',
                                    fontWeight: 'bold',
                                    color: '#fff'
                                }}>
                                    {item.UNSE_TITLE}
                                </div>
                                <span style={{
                                    fontSize: '11px',
                                    color: '#51cf66',
                                    padding: '3px 8px',
                                    background: 'rgba(81, 207, 102, 0.15)',
                                    borderRadius: '4px'
                                }}>
                                    결과보기
                                </span>
                            </div>
                            <div style={{
                                fontSize: '12px',
                                color: '#888'
                            }}>
                                {new Date(item.REG_DATE).toLocaleDateString('ko-KR', {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                })} {formatDate(item.REG_DATE)}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default FortuneHistory;
